import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { DirectLinkSource } from '@lyrahealth-inc/shared-app-logic/src/features/searchForCare/constants'
import { useNavigateToWellnessToolkit as useNavigateToWellnessToolkitShared } from '@lyrahealth-inc/shared-app-logic/src/features/wellnessToolkit/hooks/useNavigateToWellnessToolkit'
import {
  isWellnessToolkitReturnDestination,
  TOOLKIT_TYPE,
  WELLNESS_TOOLKIT_PROMOTION,
  WellnessToolkitNavigationParams,
} from '@lyrahealth-inc/shared-app-logic/src/features/wellnessToolkit/types'

import { useAppDispatch } from '../../data/storeConfiguration/store'
import { setDirectLinkSource, setToolkitType } from '../../features/onboard/data/onboardDataActions'

export const useNavigateToWellnessToolkit = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const navigateToWellnessToolkit = useNavigateToWellnessToolkitShared({
    setToolkitType: (toolkitPromotion: TOOLKIT_TYPE) => dispatch(setToolkitType(toolkitPromotion)),
    setDirectLinkSource: (directLinkSource) => dispatch(setDirectLinkSource(directLinkSource)),
    navigateToToolkit: (toolkitPromotion, navigationParams) => {
      const toolkitPath = `/secure/wellness/toolkit/${toolkitPromotion}`
      const returnDestination = navigationParams?.returnDestination
      const returnDestinationQuery = isWellnessToolkitReturnDestination(returnDestination)
        ? `?returnDestination=${encodeURIComponent(returnDestination)}`
        : ''

      navigate(`${toolkitPath}${returnDestinationQuery}`, {
        state: navigationParams,
      })
    },
  })

  return useCallback(
    ({
      toolkitPromotion,
      directLinkSource,
      navigationParams,
    }: {
      toolkitPromotion: WELLNESS_TOOLKIT_PROMOTION
      directLinkSource: DirectLinkSource
      navigationParams?: WellnessToolkitNavigationParams
    }) => {
      navigateToWellnessToolkit({ toolkitPromotion, directLinkSource, navigationParams })
    },
    [navigateToWellnessToolkit],
  )
}
